import {PartnerPersonSummaryModel} from '../entity/partnerPersonSummary.model';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PersonSummaryConverter} from '../../../../../person/api/converter/personSummary.converter';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PartnerPersonSummaryConverter extends HttpModelConverter<PartnerPersonSummaryModel>{

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): PartnerPersonSummaryModel {
        return new PartnerPersonSummaryModel();
    }

    protected enrichObject(result: PartnerPersonSummaryModel, src: PartnerPersonSummaryModel) {
        result.person = new PersonSummaryConverter().convert(src.person);
        result.type = this.lovValueSummaryConverter.convert(src.type);
    }
}
